import type { IconProps } from './types';

export const DeleteIcon = (props: IconProps) => {
  const {
    size = 18,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M4.71429 7.75H19.2857"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.53571 7.75H17.4643V18.6786C17.4643 19.0006 17.3363 19.3095 17.1086 19.5372C16.8809 19.7649 16.572 19.8929 16.25 19.8929H7.74999C7.42794 19.8929 7.11908 19.7649 6.89136 19.5372C6.66364 19.3095 6.53571 19.0006 6.53571 18.6786V7.75Z"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.96429 7.75V7.14286C8.96429 6.33774 9.28413 5.56559 9.85343 4.99628C10.4227 4.42698 11.1949 4.10714 12 4.10714C12.8051 4.10714 13.5773 4.42698 14.1466 4.99628C14.7159 5.56559 15.0357 6.33774 15.0357 7.14286V7.75"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1786 11.3946V16.2536"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8214 11.3946V16.2536"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
